import { useState, useRef, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import AuthContext from '../store/AuthProvider';
import classes from './Login.module.css';

const apikey = process.env['REACT_APP_AUTH_APIKEY'];

const Login = () => {
  const history = useHistory();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();

  const authCtx = useContext(AuthContext);

  const [isLogin, setIsLogin] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [formError, setFormError] = useState('');

  const switchAuthModeHandler = () => {
    setIsLogin((prevState) => !prevState);
    setEmailError('');
    setPasswordError('');
    setFormError('');
  };

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredEmail = emailInputRef.current.value;
    const enteredPassword = passwordInputRef.current.value;

    setIsLoading(true);
    setEmailError('');
    setPasswordError('');
    setFormError('');

    let url;
    if (isLogin) {
      url = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${apikey}`;
    } else {
      url = `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${apikey}`;
    }

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        email: enteredEmail,
        password: enteredPassword,
        returnSecureToken: true,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        setIsLoading(false);
        return res.json().then((data) => {
          if (!res.ok) {
            throw new Error(data.error.message);
          }
          return data;
        });
      })
      .then((data) => {
        const expirationTime = new Date(
          new Date().getTime() + +data.expiresIn * 1000
        );
        authCtx.login(data.idToken, expirationTime.toISOString(), data.localId);
        history.replace('/mypage');
      })
      .catch((err) => {
        const msg = err.message;

        if (msg.includes('WEAK_PASSWORD')) {
          setPasswordError('Password must be at least 6 characters.');
        } else if (msg.includes('EMAIL_EXISTS')) {
          setEmailError('This email is already registered.');
        } else if (msg.includes('INVALID_EMAIL')) {
          setEmailError('Please enter a valid email address.');
        } else if (
          msg.includes('EMAIL_NOT_FOUND') ||
          msg.includes('INVALID_PASSWORD')
        ) {
          setFormError('Email or password is incorrect.');
        } else {
          alert('Authentication error: ' + msg);
        }
      });
  };

  return (
    <section className={classes.auth}>
      <h1>{isLogin ? 'Login' : 'Sign Up'}</h1>
      <form onSubmit={submitHandler}>
        <div className={classes.control}>
          <label htmlFor='email'>Your Email</label>
          <input
            type='email'
            id='email'
            required
            ref={emailInputRef}
            autoComplete="email"
          />
          {emailError && <p className={classes.error}>{emailError}</p>}
        </div>
        <div className={classes.control}>
          <label htmlFor='password'>Your Password</label>
          <input
            type='password'
            id='password'
            required
            ref={passwordInputRef}
            autoComplete={isLogin ? 'current-password' : 'new-password'}
          />
          {passwordError && <p className={classes.error}>{passwordError}</p>}
        </div>
        <div className={classes.actions}>
          {!isLoading && (
            <>
              <button>{isLogin ? 'Login' : 'Create Account'}</button>
              {formError && <p className={classes.error}>{formError}</p>}
            </>
          )}
          {isLoading && <p>Sending request...</p>}
          <button
            type='button'
            className={classes.toggle}
            onClick={switchAuthModeHandler}
          >
            {isLogin ? 'Create new account' : 'Login with existing account'}
          </button>
        </div>
      </form>
    </section>
  );
};

export default Login;
